<template>
  <div class="countdown">
    <div class="countdown-wrapper">
      <div class="countdown-content">
        <div class="countdown-timer-w-hrs">
          <hr class="hr-aqua" />
          <div class="countdown-timer">
            <div class="countdown-timer__item" v-if="days">
              <div class="countdown-timer__item-value">{{ days }}</div>
              <div class="countdown-timer__item-label">days</div>
            </div>
            <div class="countdown-timer__item">
              <div class="countdown-timer__item-value">
                {{ hours }}
              </div>
              <div class="countdown-timer__item-label">hrs</div>
            </div>
            <div class="countdown-timer__item">
              <div class="countdown-timer__item-value">
                {{ minutes }}
              </div>
              <div class="countdown-timer__item-label">mins</div>
            </div>
            <div class="countdown-timer__item">
              <div class="countdown-timer__item-value">
                {{ seconds }}
              </div>
              <div class="countdown-timer__item-label">secs</div>
            </div>
          </div>
          <hr class="hr-aqua" />
        </div>
        <hr class="mobile-hr hr-aqua" />

        <div class="countdown__text">
          Countdown to <br class="br-mobile" />St. Jude Partner
          <br class="br-mobile" />Summit
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Countdown",
  props: {
    value: Object
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null
    };
  },
  created() {
    this.startCountdown();
  },
  methods: {
    startCountdown() {
      this.calc();

      this.interval = setInterval(() => {
        this.calc();
      }, 1000);
    },
    daysWithoutMonths(ms) {
      let days = Math.floor(ms / 1000 / 60 / 60 / 24);
      if (days < 0) days = 0;
      return days;
    },
    calc() {
      const release = this.$moment(this.value.release_date);
      const today = this.$moment(new Date());
      const diff = release.diff(today);
      const duration = this.$moment.duration(diff, "milliseconds");

      const days = this.daysWithoutMonths(diff);
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
        this.$emit("update");
      }

      this.days = days;
      this.hours = hours < 10 ? "0" + hours : hours;
      this.minutes = minutes < 10 ? "0" + minutes : minutes;
      this.seconds = seconds < 10 ? "0" + seconds : seconds;
    }
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.countdown-wrapper {
  min-height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  font-weight: 600;
  color: white;
  background: url(~@/assets/countdown-bg.jpg);
  background-blend-mode: multiply, normal;
  mix-blend-mode: darken;
  background-position: center;
  background-size: cover;
  hr {
    flex: 1;
    height: 4px;
  }
  hr.mobile-hr {
    display: none;
  }
  hr:not(.mobile-hr) {
    margin-bottom: 0.75em;
    margin-top: 0;
  }
}
.countdown-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.countdown__text {
  margin-top: 10px;
  font-weight: 800;
  font-size: 36px;
  line-height: 36px;
  text-align: center;
}

.countdown-timer {
  display: flex;
  align-items: center;
  margin: 0 5%;

  &-w-hrs {
    display: flex;
    align-items: flex-end;
    width: 100%;
  }

  &__item {
    margin: 0 19px;

    &:first-child {
      margin-left: 0;
    }
    &:last-child {
      margin-right: 0;
    }
  }

  &__item {
    text-align: center;
  }
  &__item-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  &__item-value {
    text-align: center;
    text-transform: uppercase;
    color: white;
    font-weight: 800;
    font-size: 52px;
    line-height: 52px;
  }
}

.br-mobile {
  display: none;
}

@media screen and (max-width: 960px) {
  .countdown-wrapper {
    padding: 20px 12px;
    hr:not(.mobile-hr) {
      display: none;
    }
    hr.mobile-hr {
      display: block;
      width: 100%;
      background-color: white;
      padding: 1px;
      margin: 15px 0 !important;
    }
  }
  .countdown-content {
    margin: 0;
  }
  .countdown-timer {
    margin: 15px 0;
    height: 30px;
    padding: 30px 0;

    &-w-hrs {
      justify-content: center;
    }

    &__item {
      margin: 0 18px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 55px;

      &-value {
        font-size: 52px;
      }
      &-label {
        font-size: 16px;
        margin: 0 10px;
      }
    }
  }
  .countdown__text {
    margin-top: 5px;
  }
  .br-mobile {
    display: initial;
  }
}
</style>
